import { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import useAuth from "../utils/context/auth-context";

export function AuthGuard({ children }: { children: JSX.Element }) {
  const navigate = useNavigate();
  const { auth, profile } = useAuth();
  const location = useLocation();

  const authToken = localStorage.getItem("_chuck-38e6e39a-ab69-4aac-bb0c");

  if (!authToken) return <Navigate to="/auth/login" replace />;

  if (
    profile?.nic_status === "reupload_required" &&
    !location.pathname.includes("/profile/nic-upload")
  ) {
    return <Navigate to="/profile/nic-upload" replace />;
  }

  // useEffect(() => {
  //   if (!auth) {
  //     navigate("/auth/login");
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [auth]);

  return children;
}
export function ReversGuard({ children }: { children: JSX.Element }) {
  const navigate = useNavigate();
  const { auth, profile } = useAuth();
  const location = useLocation();

  // Get authorization redirect
  const queryParams = new URLSearchParams(location.search);
  const platform = queryParams.get("platform");
  const clientId = queryParams.get("client_id");

  useEffect(() => {
    if (platform === "pc" && clientId && auth) {
      navigate(`/authorize?platform=${platform}&client_id=${clientId}`, {
        replace: true,
      });
    } else if (auth) {
      if (profile?.nic_status === "reupload_required") {
        window.location.href = "/profile/nic-upload";
      } else {
        navigate("/profile", { replace: true });
      }
    }
  }, [auth, profile, platform, clientId, navigate]);

  // if (authToken) return <Navigate to="/profile" replace />;
  // useEffect(() => {
  //   if (auth) {
  //     navigate("/profile");
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [auth]);

  return children;
}
